import React from 'react';

const SectionHeader = ({ 
  itemKey, 
  zones, 
  doc2Visibility, 
  toggleDoc2Visibility, 
  handleSectionExport, 
  markAllCheckboxes 
}) => {
  const sectionId = `Red ${zones["Zone 1"]} vs. ${zones["Zone 2"]}`;
  
  return (
    <div style={{
      display: 'flex',
      position: 'inline',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '100%',
      marginTop: '0px',
    }}>                           
      <label style={{
        position: "relative",
        top: "0px",
        bottom: "0px",
        right: "7.5%",
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        fontStyle: "italic",
        color: "rgb(82, 102, 102)",
      }}>
        <span
          onClick={() => handleSectionExport(sectionId)}
          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            marginRight: '8px',
            border: '2px solid #526666',
            borderRadius: '4px',
            backgroundColor: markAllCheckboxes.has(sectionId)
              ? '#526666'
              : 'transparent',
            cursor: 'pointer',
            position: 'relative',
            padding: '0 2px'
          }}
          id={sectionId}
        >
          {markAllCheckboxes.has(sectionId) && (
            <span
              style={{
                position: 'absolute',
                top: '-8px',
                left: '0px',
                fontSize: '24px',
                color: 'white',
                padding: '0 0 0 2px',
                margin: '0'
              }}
            >
              ✔
            </span>
          )}
        </span>
        Mark Section For Export
      </label>
      
      <section
        style={{
          fontStyle: 'italic',
          fontSize: '13px',
          color: '#526666',
          padding: '2px 0px',
          display: 'inline',
          alignItems: 'center',
          margin: '2px',
          cursor: 'pointer',
          position: 'relative',
          width: '10%',
          overflowY: "hidden",
          overflowX: "hidden",
        }}
        onClick={() => toggleDoc2Visibility(itemKey + "_red")}
      >
        {doc2Visibility[itemKey + "_red"] ? 'Expand Section' : 'Collapse Section'}
        <span
          style={{
            marginLeft: '8px',
            display: 'inline-block',
            width: '0',
            height: '0',
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            borderLeft: '8px solid #526666',
            transform: doc2Visibility[itemKey + "_red"] ? 'rotate(0deg)' : 'rotate(90deg)',
            transformOrigin: '4px 50%',
            transition: 'transform 0.2s ease',
          }}
        ></span>
      </section>
    </div>
  );
};

export default SectionHeader;
